import { ChangeDetectionStrategy, Component, DOCUMENT, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SessionStorageService } from '@shared/services/storage.service';
import { environment } from '../../environments/environment';

@Component({
	selector: 'app-core',
	templateUrl: './core.component.html',
	styleUrls: ['./core.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CoreComponent {
	theme: string = 'my-light-theme';

	constructor(
		private sessionStorageService: SessionStorageService,
		private route: ActivatedRoute,
		@Inject(DOCUMENT) private document: Document,
	) {
		this.sessionStorageService.remove('Selected.ServiceName');
	}

	ngOnInit(): void {
		// Remove invite token if we're not coming to the signin page from the invite flow
		this.route.params.subscribe((params) => {
			if (Object.keys(params).length !== 0) {
				this.document.location.href = `${environment.oAuthUri}/logout`;
			}
		});
	}
}
